import React, { useRef, useEffect, useState } from "react";
import XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faFilter, faColumns, faPlus, faTimes, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { components } from "react-select";
import { default as ReactSelect } from "react-select";
import DatePickerCustom from "./DatePicker";
import dayjs from "dayjs";
import { useAuth } from "../services/auth.service";
import axios from "axios";
//create a react component who loads data from axios and render it as a table
export default function Renovacion() {
  const [polizas, setPolizas] = useState([]);
  const [polizasFiltered, setPolizasFiltered] = useState([]);
  const [filters, setFilters] = useState([]);
  const [templateSent, setTemplateSent] = useState([]);
  const [selectedTemplateSent, setSelectedTemplateSent] = useState([]);
  const [aseguradoras, setAseguradoras] = useState([]);
  const [selectedAseguradoras, setSelectedAseguradoras] = useState([]); //array of objects [{value: "AXA", label: "AXA"}, {value: "MAPFRE", label: "MAPFRE"}
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursales, setSelectedSucursales] = useState([]); //array of objects [{value: "AXA", label: "AXA"}, {value: "MAPFRE", label: "MAPFRE"}
  const [statuses, setStatuses] = useState([]);
  const [currentMessageStatuses, setCurrentMessageStatuses] = useState([]); //array of objects [{value: "AXA", label: "AXA"}, {value: "MAPFRE", label: "MAPFRE"}
  const [mensajesStatus, setMensajesStatus] = useState([]);
  const [ramos, setRamos] = useState([]);
  const [selectedRamos, setSelectedRamos] = useState([]); //array of objects [{value: "AXA", label: "AXA"}, {value: "MAPFRE", label: "MAPFRE"}
  const [tipos, setTipos] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]); //plain array
  const [sortedAs, setSortedAs] = useState("asc");
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [sentItems, setSentItems] = useState(0);
  const [modalMessageBody, setModalMessageBody] = useState("");
  const [modalStep, setModalStep] = useState("confirm");
  const [previewMessage, setPreviewMessage] = useState(null);
  const [variableOverrides, setVariableOverrides] = useState({});
  const [customTestPhone, setCustomTestPhone] = useState("");
  const [testSendStatus, setTestSendStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM"));
  const { user, logout } = useAuth();
  const [inverseFilter, setInverseFilter] = useState(false);
  const [columnsModalOpen, setColumnsModalOpen] = useState(false);
  const [availableColumns, setAvailableColumns] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilterColumns, setActiveFilterColumns] = useState([]);
  const [columnFilters, setColumnFilters] = useState({});
  const [isDarkMode, setIsDarkMode] = useState(false);

  const [selectedTipoRenovacion, setSelectedTipoRenovacion] = useState({ id: 1, name: "Por Vencer" });


  const TipoRenovacionList = [
    { id: 1, name: "Por Vencer" },
    { id: 2, name: "Vencidas" },
  ]

  const preferredColumnOrder = [
    "Asegurado",
    "Templates_Sent",
    "currentMessageStatus",
    "newMessages",
    "chat",
    "Cedula",
    "Aseguradora",
    "Sucursal",
    "Nro_Poliza",
    "Ramo",
    "Estatus",
    "Tipo_Renovacion",
    "Vencimiento",
    "Saldo",
  ];
  const [selectedVisibleColumns, setSelectedVisibleColumns] = useState(preferredColumnOrder);
  const columnLabelMap = {
    Templates_Sent: "Plantilla",
    currentMessageStatus: "Estatus Mensaje",
    newMessages: "Cliente Resp",
    chat: "Chat",
    Nro_Poliza: "Nro Poliza",
    Tipo_Renovacion: "Tipo Renovacion",
    Vencimiento: "Venc",
  };
  const topControlClassName =
    isDarkMode
      ? "text-sm text-[#d1d5db] border border-[#2b313d] rounded-lg bg-[#0f1115] px-3 py-2 focus:ring-2 focus:ring-[#3b82f6] focus:border-[#3b82f6]"
      : "text-sm text-gray-700 border border-gray-300 rounded-lg bg-white px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500";
  const reactSelectFilterStyles = {
    control: (base) => ({
      ...base,
      minHeight: "36px",
      borderColor: isDarkMode ? "#2b313d" : "#d1d5db",
      boxShadow: "none",
      borderRadius: "0.375rem",
      backgroundColor: isDarkMode ? "#0f1115" : "#ffffff",
      color: isDarkMode ? "#d1d5db" : "#374151",
    }),
    singleValue: (base) => ({ ...base, color: isDarkMode ? "#d1d5db" : "#374151" }),
    input: (base) => ({ ...base, color: isDarkMode ? "#d1d5db" : "#374151" }),
    placeholder: (base) => ({ ...base, color: isDarkMode ? "#94a3b8" : "#6b7280" }),
    multiValue: (base) => ({ ...base, backgroundColor: isDarkMode ? "#1f2430" : "#f3f4f6" }),
    multiValueLabel: (base) => ({ ...base, color: isDarkMode ? "#cbd5e1" : "#374151" }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuList: (base) => ({ ...base, backgroundColor: isDarkMode ? "#111827" : "#ffffff" }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused
        ? (isDarkMode ? "#1f2937" : "#f3f4f6")
        : (isDarkMode ? "#111827" : "#ffffff"),
      color: isDarkMode ? "#d1d5db" : "#374151",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 30,
      backgroundColor: isDarkMode ? "#111827" : "#ffffff",
    }),
  };

  useEffect(() => {
    let templatesSents = [
      ...new Set(templates.map((template) => template.name)),
    ];
    setTemplateSent(templatesSents);
    let aseguradoras = [
      ...new Set(polizas.map((poliza) => poliza.Aseguradora)),
    ];
    setAseguradoras(aseguradoras);
    //get from polizas the distinct statuses
    let statuses = [...new Set(polizas.map((poliza) => poliza.Estatus))];
    setStatuses(statuses);
    // //get from polizas the distinct tipos
    let tipos = [...new Set(polizas.map((poliza) => poliza.Tipo_Renovacion))];
    setTipos(tipos);
    // //get from polizas the distinct ramos
    let ramos = [...new Set(polizas.map((poliza) => poliza.Ramo))];
    setRamos(ramos);
    let sucursales = [...new Set(polizas.map((poliza) => poliza.Sucursal))];
    setSucursales(sucursales);
    let MensajesStatus = [
      ...new Set(polizas.map((poliza) => poliza.Mensaje_Status)),
    ];
    setMensajesStatus(MensajesStatus);
    let currentMessageStatuses = [
      ...new Set(polizas.map((poliza) => poliza.currentMessageStatus)),
    ];
    setCurrentMessageStatuses(currentMessageStatuses);

    setPolizasFiltered(polizas);

    const endpointColumns = Array.from(
      new Set(
        polizas
          .slice(0, 100)
          .flatMap((poliza) => Object.keys(poliza || {}))
      )
    );
    const mergedColumns = Array.from(
      new Set([...preferredColumnOrder, ...endpointColumns])
    );
    const sortedColumns = mergedColumns.sort((a, b) => {
      const indexA = preferredColumnOrder.indexOf(a);
      const indexB = preferredColumnOrder.indexOf(b);
      if (indexA === -1 && indexB === -1) return a.localeCompare(b);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
    setAvailableColumns(sortedColumns);
    setSelectedVisibleColumns((prev) => {
      if (!prev?.length) return sortedColumns;
      const stillAvailable = prev.filter((column) => sortedColumns.includes(column));
      return stillAvailable.length ? stillAvailable : sortedColumns;
    });
  }, [polizas]);

  useEffect(() => {
    if (user)
      fetch(
        `${process.env.REACT_APP_BACKEND_API}/renovaciones/polizas?Mes=${selectedDate.split("-")[1]
        }&Ano=${selectedDate.split("-")[0]}&TipoRenovacion=${selectedTipoRenovacion.id}${user.roles[0] == 'ROLE_ADMIN' ? '' : '&SoloActivas=1'}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": user.accessToken,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (user.roles[0] == 'ROLE_ADMIN') {
            setPolizas(data);
          }
          else {
            setPolizas(data.filter((poliza) => poliza.Estatus == 'ACTIVA'));
          }
        });

    //load templates
    async function loadTemplates() {
      const url = process.env.REACT_APP_BACKEND_API + "/template";
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      let result = await axios
        .get(url, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
      if (result.data)
        setTemplates(result.data);
    }
    loadTemplates();
  }, [selectedDate, selectedTipoRenovacion]);

  const handleDateChange = (date) => {
    setPolizasFiltered([]);
    let year = date.$y;
    //let the month append a 0 if it is less than 10
    let month = date.$M + 1 < 10 ? `0${date.$M + 1}` : date.$M + 1;
    setSelectedDate(`${year}-${month}`);
  };

  const SelectCheckOptions = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const splitURL = (url) => {
    let encoded = "";
    try {
      const split = url.split("/");
      const filename = split[split.length - 1];
      //convert string into urlencode
      encoded = encodeURIComponent(filename);
    } catch (error) {
      encoded = "noexiste.PNG";
    }
    return encoded;
  };

  const getTemplateVariableCount = (template) => {
    if (!template) return 0;
    const bodyMatches = [...(template.body || "").matchAll(/\{\{(\d+)\}\}/g)].map((m) => Number(m[1]));
    const maxBodyIndex = bodyMatches.length ? Math.max(...bodyMatches) : 0;
    const parameterCount = Array.isArray(template.parameters) ? template.parameters.length : 0;
    return Math.max(maxBodyIndex, parameterCount);
  };

  const getParameterValuesForPoliza = (template, poliza, overrides = {}) => {
    const normalizedCompositeVariables = Array.isArray(template?.compositeVariables)
      ? template.compositeVariables
          .map((item) => ({
            name: `${item?.name || ""}`.trim(),
            expression: `${item?.expression || ""}`.trim(),
          }))
          .filter((item) => item.name && item.expression)
      : [];
    const compositeVariableMap = normalizedCompositeVariables.reduce((acc, item) => {
      acc[item.name] = item.expression;
      return acc;
    }, {});
    const resolveCompositeValue = (expression) =>
      `${expression || ""}`.replace(/\{([^}]+)\}/g, (_, fieldName) => {
        const key = `${fieldName}`.trim();
        return `${poliza?.[key] ?? ""}`;
      });

    const totalVariables = getTemplateVariableCount(template);
    const values = Array.from({ length: totalVariables }, (_, index) => {
      const overrideValue = overrides[index + 1];
      if (overrideValue !== undefined && `${overrideValue}`.trim() !== "") {
        return `${overrideValue}`;
      }
      const fieldName = template?.parameters?.[index]?.value;
      if (!fieldName) return "";
      if (compositeVariableMap[fieldName]) {
        return resolveCompositeValue(compositeVariableMap[fieldName]);
      }
      return poliza?.[fieldName] ?? "";
    });

    const comparisonRules = Array.isArray(template?.comparacionValores)
      ? template.comparacionValores
      : [];
    comparisonRules.forEach((rule) => {
      const sourceIndex = Number(rule?.variableOrigen || 0) - 1;
      const targetIndex = Number(rule?.variableDestino || 0) - 1;
      const compareField = `${rule?.campoComparacionEjecutivo || ""}`.trim();
      const resultField = `${rule?.campoResultadoEjecutivo || ""}`.trim();
      if (sourceIndex < 0 || targetIndex < 0 || !compareField || !resultField) return;
      const sourceValue = values[sourceIndex];
      if (sourceValue === undefined || sourceValue === null || `${sourceValue}`.trim() === "") return;

      const match = ejecutivos.find((ejecutivo) => {
        const ejecutivoValue = ejecutivo?.[compareField];
        if (ejecutivoValue === undefined || ejecutivoValue === null) return false;
        return `${ejecutivoValue}`.trim().toLowerCase() === `${sourceValue}`.trim().toLowerCase();
      });
      if (!match) return;
      const replacement = match?.[resultField];
      if (replacement === undefined || replacement === null || `${replacement}`.trim() === "") return;
      values[targetIndex] = `${replacement}`;
    });

    return values;
  };

  const getTemplateVariableValue = (values, variableNumber) => {
    const index = Number(variableNumber || 0) - 1;
    if (index < 0) return "";
    return `${values[index] ?? ""}`.trim();
  };

  const buildContactAssignmentPayload = (template, poliza, resolvedValues) => {
    const assignment = template?.asignacionEjecutivo || {};
    const ejecutivoName = getTemplateVariableValue(resolvedValues, assignment.variableEjecutivoNombre);
    const ejecutivoIdField = `${assignment?.campoEjecutivoId || ""}`.trim();
    const fallbackEjecutivoId = `${assignment?.fallbackEjecutivoId || ""}`.trim();
    const nombreClienteFromVar = getTemplateVariableValue(resolvedValues, assignment.variableNombreCliente);
    const nombreCliente = nombreClienteFromVar || poliza?.Asegurado || "";

    const normalizeText = (value) => `${value ?? ""}`.trim().toLowerCase();
    const matchedEjecutivo = ejecutivos.find((ejecutivo) => {
      if (!ejecutivoName) return false;
      const fullName = `${ejecutivo?.firstName || ""} ${ejecutivo?.lastName || ""}`.trim();
      return (
        normalizeText(ejecutivo?.firstName) === normalizeText(ejecutivoName) ||
        normalizeText(ejecutivo?.lastName) === normalizeText(ejecutivoName) ||
        normalizeText(fullName) === normalizeText(ejecutivoName) ||
        normalizeText(ejecutivo?.name) === normalizeText(ejecutivoName)
      );
    });
    const fallbackEjecutivoFromTemplate = fallbackEjecutivoId
      ? ejecutivos.find((ejecutivo) => `${ejecutivo?._id || ""}`.trim() === fallbackEjecutivoId)
      : null;
    const fallbackEjecutivo = fallbackEjecutivoFromTemplate || selectedEjecutivo || null;
    const ejecutivoSource = matchedEjecutivo || fallbackEjecutivo;
    const ejecutivoId = ejecutivoIdField && ejecutivoSource ? `${ejecutivoSource[ejecutivoIdField] ?? ""}`.trim() : "";
    const finalEjecutivoName = matchedEjecutivo
      ? ejecutivoName
      : `${ejecutivoSource?.firstName || ""} ${ejecutivoSource?.lastName || ""}`.trim() || ejecutivoName;

    const hasExecutiveAssignment = finalEjecutivoName && ejecutivoId;
    return {
      wa_id: poliza?.Celular || "",
      NombreCompleto: nombreCliente,
      notas: "",
      etiquetas: [],
      ejecutivoAsignado: hasExecutiveAssignment
        ? [{ value: ejecutivoId, label: finalEjecutivoName, selected: false }]
        : [],
      sucursalChat: [],
      _preview: {
        ejecutivoName: finalEjecutivoName,
        ejecutivoId,
        ejecutivoIdField,
        fallbackEjecutivoId,
        nombreCliente,
      },
    };
  };

  const updateContactAssignment = async (poliza, template, resolvedValues) => {
    if (!poliza?.Celular) return;
    const payload = buildContactAssignmentPayload(template, poliza, resolvedValues);
    await fetch(`${process.env.REACT_APP_BACKEND_API}/contacts/${poliza.Celular}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": user.accessToken,
      },
      body: JSON.stringify({
        wa_id: payload.wa_id,
        NombreCompleto: payload.NombreCompleto,
        notas: payload.notas,
        etiquetas: payload.etiquetas,
        ejecutivoAsignado: payload.ejecutivoAsignado,
        sucursalChat: payload.sucursalChat,
      }),
    }).catch(() => null);
  };

  const sendTemplateMessages = (e) => {
    e.preventDefault();
    if (checkedItems.length == 0 || !selectedTemplate) {
      return;
    }
    const firstPoliza = polizas.find((poliza) => poliza._id == checkedItems[0]);
    if (!firstPoliza) return;

    const previewParams = getParameterValuesForPoliza(selectedTemplate, firstPoliza, {});
    let previewBody = selectedTemplate.body || "";
    previewBody = previewBody.replace(/\{\{(\d+)\}\}/g, (_, index) => {
      const value = previewParams[Number(index) - 1];
      return value ?? `{{${index}}}`;
    });

    setPreviewMessage({
      to: firstPoliza.Celular,
      body: previewBody,
      image: selectedTemplate.image,
      asegurado: firstPoliza.Asegurado,
      total: checkedItems.length,
    });
    setModalStep("confirm");
    setModalMessageBody("");
    setSentItems(0);
    setVariableOverrides({});
    setCustomTestPhone(firstPoliza.Celular || "");
    setTestSendStatus("");
    openModal();
  };

  const sendTestTemplateMessage = async () => {
    if (checkedItems.length === 0 || !selectedTemplate || !customTestPhone.trim()) return;
    const firstPoliza = polizas.find((poliza) => poliza._id == checkedItems[0]);
    if (!firstPoliza) return;
    setTestSendStatus("Enviando prueba...");

    const resolvedValues = getParameterValuesForPoliza(selectedTemplate, firstPoliza, variableOverrides);
    await updateContactAssignment(firstPoliza, selectedTemplate, resolvedValues);

    const payloadBase = {
      templateID: selectedTemplate.name,
      to: customTestPhone.trim(),
      parameters: resolvedValues.map((value) => ({
        type: "text",
        value,
      })),
      header: {
        image: selectedTemplate.image,
      },
      buttonParametersIndex: selectedTemplate.buttonparameterindex,
    };

    const buttonParameters =
      selectedTemplate.buttonparameters.length > 0
        ? selectedTemplate.buttonparameters.map((buttonParameter) => {
          if (selectedTemplate.type === "quickreply") {
            return {
              type: "payload",
              value: buttonParameter.value,
            };
          }
          return {
            type: "text",
            value:
              buttonParameter.value == "DocumentoPoliza"
                ? splitURL(firstPoliza[buttonParameter.value])
                : firstPoliza[buttonParameter.value],
          };
        })
        : [];

    const body =
      selectedTemplate.type !== "quickreply"
        ? JSON.stringify({
          ...payloadBase,
          buttonParameters,
        })
        : JSON.stringify({
          ...payloadBase,
          quickReplies: true,
          dataId: firstPoliza._id,
          buttonParameters,
        });

    const result = await fetch(`${process.env.REACT_APP_BACKEND_API}/messages/sendtemplatemessage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": user.accessToken,
      },
      body,
    })
      .then((response) => response.json())
      .catch(() => null);

    if (!result || result.error) {
      setTestSendStatus(result?.error?.message || "No se pudo enviar mensaje de prueba");
      return;
    }
    setTestSendStatus("Mensaje de prueba enviado");
  };

  const confirmSendTemplateMessages = () => {
    if (checkedItems.length == 0 || !selectedTemplate) return;
    setModalStep("sending");
    setModalMessageBody("Enviando mensajes...");
    const queue = [...checkedItems];
    const totalItems = queue.length;
    //send each message at 3 seconds interval
    const interval = setInterval(() => {
      let id = queue.shift();
      if (id) {
        let poliza = {};
        if (selectedEjecutivo) {
          poliza = polizas.find((poliza) => poliza._id == id);
          poliza.ejecutivoSucursal = selectedEjecutivo.firstName + ' ' + selectedEjecutivo.lastName;
          poliza.ejecutivoId = selectedEjecutivo._id;
        } else {
          poliza = polizas.find((poliza) => poliza._id == id);
        }
        if (selectedTemplate.name == 'recuperar_cliente') {
          poliza.ejecutivoSucursal = 'danelis jaen';
          poliza.ejecutivoId = '64a309f060d160d564ad8a2a';
        }
        //check if the poliza has the selected template
        if (
          poliza.Templates_Sent?.filter(
            (templatesent) => templatesent.TemplateName == selectedTemplate.name
          ).length == 0 ||
          !poliza.Templates_Sent
        )
          (async () => {
            const resolvedValues = getParameterValuesForPoliza(selectedTemplate, poliza, variableOverrides);
            await updateContactAssignment(poliza, selectedTemplate, resolvedValues);
            return fetch(`${process.env.REACT_APP_BACKEND_API}/messages/sendtemplatemessage`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-access-token": user.accessToken,
              },
              body: selectedTemplate.type !== "quickreply" ? JSON.stringify({
                templateID: selectedTemplate.name,
                to: poliza.Celular,
                parameters: resolvedValues.map((value) => {
                  return { type: "text", value };
                }),
                header: {
                  image: selectedTemplate.image,
                },
                buttonParametersIndex: selectedTemplate.buttonparameterindex,
                buttonParameters:
                  selectedTemplate.buttonparameters.length > 0
                    ? selectedTemplate.buttonparameters.map(
                      (buttonParameter) => {
                        return {
                          type: "text",
                          value:
                            buttonParameter.value == "DocumentoPoliza"
                              ? splitURL(poliza[buttonParameter.value])
                              : poliza[buttonParameter.value],
                        };
                      }
                    )
                    : [],
                subscribedTo: '64d18f536d53886eb99c18f2',
                subscribedObjectId: poliza._id,
              }) : JSON.stringify({
                templateID: selectedTemplate.name,
                to: poliza.Celular,
                parameters: resolvedValues.map((value) => {
                  return { type: "text", value };
                }),
                header: {
                  image: selectedTemplate.image,
                },
                quickReplies: true,
                dataId: poliza._id,
                buttonParametersIndex: selectedTemplate.buttonparameterindex,
                buttonParameters:
                  selectedTemplate.buttonparameters.length > 0
                    ? selectedTemplate.buttonparameters.map(
                      (buttonParameter) => {
                        return {
                          type: "payload",
                          value: buttonParameter.value,
                        };
                      }
                    )
                    : [],
              }),
            });
          })()
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                setModalMessageBody(data.error.message);
                return;
              }
              //set sentItems to update the progress bar using the checkedItems.length
              if (data.messages) {
                //update the poliza with the message status
                let actualTemplateMessages = poliza.Templates_Sent;
                if (actualTemplateMessages) {
                  //check if there is a TemplateName named Pendiente
                  if (
                    actualTemplateMessages.filter(
                      (template) => template.TemplateName == "Pendiente"
                    ).length > 0
                  ) {
                    //remove the item
                    actualTemplateMessages = actualTemplateMessages.filter(
                      (template) => template.TemplateName != "Pendiente"
                    );
                  }
                  actualTemplateMessages.push({
                    TemplateName: selectedTemplate.name,
                    Mensaje_Status: "Enviado",
                    Message_ID: data.messages[0].id,
                    Message_Timestamp: new Date().getTime(),
                  });
                } else {
                  actualTemplateMessages = [
                    {
                      TemplateName: selectedTemplate.name,
                      Mensaje_Status: "Enviado",
                      Message_ID: data.messages[0].id,
                      Message_Timestamp: new Date().getTime(),
                    },
                  ];
                }
                //wait 2 seconds
                setTimeout(() => {

                  fetch(
                    `${process.env.REACT_APP_BACKEND_API}/renovaciones/polizas/${id}`,
                    {
                      method: "PUT",
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": user.accessToken,
                      },
                      body: JSON.stringify({
                        Templates_Sent: actualTemplateMessages,
                        wa_id: poliza["Celular"],
                        ejecutivoSucursal: selectedEjecutivo ? selectedEjecutivo.firstName + ' ' + selectedEjecutivo.lastName : selectedTemplate.name !== 'recuperar_cliente' ? poliza["ejecutivoSucursal"] : 'danelis jaen',
                        ejecutivoId: selectedEjecutivo ? selectedEjecutivo._id : selectedTemplate.name !== 'recuperar_cliente' ? poliza["ejecutivoId"] : '64a309f060d160d564ad8a2a',
                        Asegurado: poliza["Asegurado"],
                      }),
                    }
                  )
                    .then((response) => response.json())
                    .then((data) => {
                      //update the polizasFiltered
                      setPolizasFiltered(
                        polizasFiltered.map((poliza) => {
                          if (poliza._id == id) {
                            poliza.Templates_Sent = data.Templates_Sent;
                          }
                          return poliza;
                        })
                      );
                    });
                }, 2000);

              }
              setSentItems(((totalItems - queue.length) * 100) / totalItems);
              console.log(data);
            });
      } else {
        setSentItems(0);
        setModalStep("done");
        setModalMessageBody("Mensajes enviados");
        clearInterval(interval);
        checkAll({ target: { checked: false } });
      }
    }, 3000);
  };

  const selectTemplate = (e) => {
    const templateID = e.target.value;
    let template = templates.find((template) => template._id == templateID);
    if (!template.buttonparameters) template.buttonparameters = [];
    setSelectedTemplate(template);
  };

  const selectTipoRenovacion = (e) => {
    const tipoRenovacionID = e.target.value;
    setSelectedTipoRenovacion({ id: tipoRenovacionID, name: TipoRenovacionList[tipoRenovacionID - 1].name });
  }

  const openModal = () => {
    const modal = document.querySelector(".main-modal");
    modal.classList.remove("fadeOut");
    modal.classList.add("fadeIn");
    modal.style.display = "flex";
  };

  const closeModal = () => {
    const modal = document.querySelector(".main-modal");
    modal.classList.remove("fadeIn");
    modal.classList.add("fadeOut");
    setTimeout(() => {
      modal.style.display = "none";
    }, 500);
  };

  const handleCheck = (e) => {
    const id = e.target.dataset.id;
    const isChecked = e.target.checked;
    if (isChecked) {
      setCheckedItems([...checkedItems, id]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item != id));
    }
  };

  const checkAll = (e) => {
    //check all the checkboxes
    console.log(checkedItems);
    const isChecked = e.target.checked;
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    let newCheckedItems = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked != isChecked) {
        newCheckedItems.push(checkbox.dataset.id);
        checkbox.checked = isChecked;
      }
    });
    if (!isChecked) {
      setCheckedItems([]);
      return;
    }
    setCheckedItems([...newCheckedItems]);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value || "");
  };

  const handleMultipleFilter = (e, action) => {
    const filter = filters;
    let filtered = polizasFiltered.filter((poliza) => {
      for (let i = 0; i < filter.length; i++) {
        let filterFlag = false;
        for (const entry of document.getElementsByName(filter[i]).values()) {
          try {
            if (poliza[filter[i]] == entry.value) {
              filterFlag = true;
            }
            if (poliza[filter[i]][0]["TemplateName"] == entry.value) {
              filterFlag = true;
            }
          } catch (error) {
            if (poliza["Mensaje_Status"] == entry.value) {
              filterFlag = true;
            }

          }
        }
        if (!filterFlag) {
          return false;
        }
      }
      return true;
    });
    setPolizasFiltered(filtered);
    return;
  };

  const handleMultipleFilterMultipleValues = (e, action) => {
    const filter = filters;
    let filtered = []
    if (inverseFilter) {
      filtered = polizasFiltered.filter((poliza) => {
        for (let i = 0; i < filter.length; i++) {
          let filterFlag = false;
          for (const entry of document.getElementsByName(filter[i]).values()) {
            try {
              for (const templateItemMV of poliza[filter[i]]) {
                if (templateItemMV["TemplateName"] != entry.value) {
                  filterFlag = true;
                } else {
                  return false;
                }
              }
              for (const template of poliza[filter[i]]) {
                if (template["TemplateName"] == entry.value) {
                  filterFlag = true;
                }
              }
              if (poliza[filter[i]] != entry.value) {
                filterFlag = true;
              }
            } catch (error) {
              if (poliza["Mensaje_Status"] != entry.value) {
                filterFlag = true;
              }
            }
          }
          if (!filterFlag) {
            return false;
          }
        }
        return true;
      });
    }
    else {
      filtered = polizasFiltered.filter((poliza) => {
        for (let i = 0; i < filter.length; i++) {
          let filterFlag = false;
          for (const entry of document.getElementsByName(filter[i]).values()) {
            try {
              for (const template of poliza[filter[i]]) {
                if (template["TemplateName"] == entry.value) {
                  filterFlag = true;
                }
              }
              if (poliza[filter[i]] == entry.value) {
                filterFlag = true;
              }
            } catch (error) {
              if (poliza["Mensaje_Status"] == entry.value) {
                filterFlag = true;
              }
            }
          }
          if (!filterFlag) {
            return false;
          }
        }
        return true;
      });
    }
    setPolizasFiltered(filtered);
    return;
  };

  const handleFilter = (e, action) => {
    try {
      const filter = e.target.value;
      const type = e.target.dataset.tipo;
      let filtered = polizasFiltered.filter((poliza) => {
        if (poliza[type] == filter) {
          return true;
        }
        return false;
      });
      setPolizasFiltered(filtered);
      return;
    } catch (error) {
      //handle multiple selection filters
      //check if the filter exists
      if (action.name == "Aseguradora") setSelectedAseguradoras(e);
      if (action.name == "Sucursal") setSelectedSucursales(e);
      if (action.name == "Ramo") setSelectedRamos(e);
      if (action.name == "Templates_Sent") setSelectedTemplateSent(e);
      const filter = action.name;
      const filterExists = filters.find((item) => {
        if (item == filter) {
          return true;
        }
        return false;
      });
      if (!filterExists) {
        setFilters([...filters, filter]);
      } else if (filterExists && e.length == 0) {
        setFilters(filters.filter((item) => item != filter));
      }
    }
  };

  const handleFilterSaldo = (e) => {
    const filter = parseInt(e.target.value);
    const type = e.target.dataset.tipo;
    let filtered = polizasFiltered.filter((poliza) => {
      if (filter > 0) {
        if (poliza[type] >= filter) {
          return true;
        }
        return false;
      }
      if (filter < 0) {
        if (poliza[type] <= filter) {
          return true;
        }
        return false;
      }
      if (filter == 0) {
        if (poliza[type] == filter) {
          return true;
        }
        return false;
      }
    });
    setPolizasFiltered(filtered);
    return;
  };

  const sortData = (e) => {
    const type = e.target.dataset.tipo;
    if (type == "Saldo") {
      let sorted;
      if (sortedAs == "asc") {
        sorted = polizas.sort((a, b) => {
          return a.Saldo - b.Saldo;
        });
        setSortedAs("desc");
      } else {
        sorted = polizas.sort((a, b) => {
          return b.Saldo - a.Saldo;
        });
        setSortedAs("asc");
      }
      setPolizasFiltered(sorted);
    }
    return;
  };

  const resetFilters = () => {
    setPolizasFiltered(polizas);
    //put all select dropdowns on first value
    const selects = document.querySelectorAll("select");
    selects.forEach((select) => {
      select.selectedIndex = 0;
    });
    setSelectedAseguradoras([]);
    setSelectedSucursales([]);
    setSelectedRamos([]);
    setFilters([]);
    setSelectedTemplateSent([]);
    setSelectedVisibleColumns(availableColumns);
    setSearchTerm("");
    setActiveFilterColumns([]);
    setColumnFilters({});
  };

  const generateExcelFromJSON = () => {
    try {
      //get all polizas from the array ids
      let allPolizas = [];
      checkedItems.forEach((id) => {
        const poliza = polizas.find((poliza) => poliza._id == id);
        allPolizas.push({ Asegurado: poliza.Asegurado, Celular: poliza.Celular, Cedula: poliza.Cedula, Aseguradora: poliza.Aseguradora, Nro_Poliza: poliza.Nro_Poliza });
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(allPolizas);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1'); // You can change the sheet name

      // Convert the workbook to an array buffer
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      // Create a Blob and save it as an Excel file
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileName = 'my_excel_file.xlsx'; // Customize the file name
      XLSX.writeFile(workbook, fileName, { compression: true });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [selectedEjecutivo, setSelectedEjecutivo] = useState(null);
  const [ejecutivos, setEjecutivos] = useState([]);

  useEffect(() => {
    if (ejecutivos.length > 0) return;
    async function loadEjecutivos() {
      const baseApi = `${process.env.REACT_APP_BACKEND_API || ""}`.replace(/\/+$/, "");
      const fallbackBase = baseApi.replace(/\/api$/, "");
      const ejecutivoUrls = Array.from(
        new Set([`${baseApi}/ejecutivo`, `${fallbackBase}/api/ejecutivo`])
      );
      const config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      };
      let result = null;
      for (const url of ejecutivoUrls) {
        const attempt = await axios.get(url, config).catch(() => null);
        if (attempt?.data) {
          result = attempt;
          break;
        }
      }
      if (result?.data) setEjecutivos(result.data);
    }
    loadEjecutivos();

  }, [ejecutivos, user.accessToken]);

  const handleSelectedEjecutivo = (e) => {
    //search the ejecutivo object with the id
    setSelectedEjecutivo(ejecutivos.find((ejecutivo) => ejecutivo._id === e));
  }

  const toggleVisibleColumn = (column) => {
    setSelectedVisibleColumns((prev) => {
      if (prev.includes(column)) {
        if (prev.length === 1) return prev;
        return prev.filter((item) => item !== column);
      }
      return [...prev, column];
    });
  };

  const selectAllColumns = () => {
    setSelectedVisibleColumns(availableColumns);
  };

  const clearColumnsSelection = () => {
    if (!availableColumns.length) return;
    setSelectedVisibleColumns([availableColumns[0]]);
  };

  const moveVisibleColumn = (column, direction) => {
    setSelectedVisibleColumns((prev) => {
      const index = prev.indexOf(column);
      if (index === -1) return prev;
      const targetIndex = direction === "up" ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= prev.length) return prev;
      const next = [...prev];
      [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
      return next;
    });
  };

  const formatCellValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (Array.isArray(value)) {
      if (value.length === 0) return "-";
      return value
        .map((item) => {
          if (item && typeof item === "object") {
            if (item.TemplateName) return item.TemplateName;
            return JSON.stringify(item);
          }
          return `${item}`;
        })
        .join(", ");
    }
    if (typeof value === "object") return JSON.stringify(value);
    return `${value}`;
  };

  const getNormalizedValuesForColumn = (rowValue) => {
    if (rowValue === null || rowValue === undefined) return [];
    if (Array.isArray(rowValue)) {
      return rowValue
        .flatMap((item) => {
          if (item && typeof item === "object") {
            if (item.TemplateName) return [`${item.TemplateName}`];
            return Object.values(item).filter((value) => typeof value !== "object").map((value) => `${value}`);
          }
          return [`${item}`];
        })
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);
    }
    if (typeof rowValue === "object") {
      return Object.values(rowValue)
        .filter((value) => typeof value !== "object")
        .map((value) => `${value}`.trim().toLowerCase())
        .filter(Boolean);
    }
    return [`${rowValue}`.trim().toLowerCase()].filter(Boolean);
  };

  const getUniqueColumnOptions = (column) => {
    if (!column) return [];
    const values = new Set();
    polizas.forEach((poliza) => {
      getNormalizedValuesForColumn(poliza?.[column]).forEach((value) => values.add(value));
    });
    return Array.from(values)
      .sort((a, b) => a.localeCompare(b))
      .map((value) => ({ value, label: value }));
  };

  useEffect(() => {
    setColumnFilters((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((key) => {
        if (!activeFilterColumns.includes(key)) delete next[key];
      });
      return next;
    });
  }, [activeFilterColumns]);

  useEffect(() => {
    const activeFilters = Object.entries(columnFilters).filter(([, values]) => Array.isArray(values) && values.length > 0);
    const filtered = polizas.filter((poliza) => {
      if (searchTerm.trim()) {
        const normalizedSearch = searchTerm.trim().toLowerCase();
        const rowValues = selectedVisibleColumns
          .flatMap((column) => getNormalizedValuesForColumn(poliza?.[column]));
        if (!rowValues.some((value) => value.includes(normalizedSearch))) return false;
      }

      for (const [column, selectedValues] of activeFilters) {
        const rowValues = getNormalizedValuesForColumn(poliza?.[column]);
        if (!selectedValues.some((value) => rowValues.includes(`${value}`.toLowerCase()))) {
          return false;
        }
      }
      return true;
    });
    setPolizasFiltered(filtered);
  }, [polizas, searchTerm, columnFilters, selectedVisibleColumns]);

  const handleApplyColumnFilter = (column, options) => {
    if (!column) return;
    const values = (options || []).map((option) => option.value);
    setColumnFilters((prev) => ({
      ...prev,
      [column]: values,
    }));
  };

  const clearSingleFilter = (column) => {
    setColumnFilters((prev) => {
      const next = { ...prev };
      delete next[column];
      return next;
    });
  };

  const renderHeaderForColumn = (column) => columnLabelMap[column] || column;

  const renderCellForColumn = (column, poliza) => {
    if (column === "Templates_Sent") {
      return (
        <span className="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
          <span
            aria-hidden
            className={
              "absolute inset-0 opacity-50 rounded-full" +
              (poliza.Templates_Sent && poliza.Templates_Sent.filter((item) => item.TemplateName !== "Pendiente").length > 0
                ? " bg-green-200"
                : " bg-orange-200")
            }
          ></span>
          {poliza.Templates_Sent
            ? poliza.Templates_Sent.map((item, key) => <p key={`${poliza._id}-template-${key}`} className="relative">{item.TemplateName + ""}</p>)
            : "Pendiente"}
        </span>
      );
    }
    if (column === "currentMessageStatus") return poliza.currentMessageStatus ? poliza.currentMessageStatus : "Pendiente";
    if (column === "newMessages") return poliza.currentMessageStatus !== "unsent" && poliza.currentMessageStatus !== "pending" ? poliza.newMessages + " nuevos mensajes" : "Sin respuesta del cliente";
    if (column === "chat") {
      return poliza.currentMessageStatus
        ? <a href={`/dashboard/chat/${poliza.Celular}`} target="_blank" rel="noreferrer" className="text-blue-500 hover:text-blue-700">Ir al chat</a>
        : "No hay chats para esta poliza";
    }
    if (column === "Vencimiento") {
      return new Date(poliza.Vencimiento).getDate() + "/" + (new Date(poliza.Vencimiento).getMonth() + 1) + "/" + new Date(poliza.Vencimiento).getFullYear();
    }
    return formatCellValue(poliza[column]);
  };

  const currentEjecutivoForOverrides = selectedEjecutivo || ejecutivos[0] || null;
  const ejecutivoFieldOptions = currentEjecutivoForOverrides
    ? Object.keys(currentEjecutivoForOverrides).filter(
      (key) => key !== "_id" && key !== "password" && typeof currentEjecutivoForOverrides[key] !== "object"
    )
    : [];

  const previewFirstPoliza = polizas.find((item) => item._id == checkedItems[0]);
  const previewResolvedValues = (() => {
    if (!selectedTemplate || !previewFirstPoliza) return [];
    return getParameterValuesForPoliza(selectedTemplate, previewFirstPoliza, variableOverrides);
  })();
  const previewContactAssignment = (() => {
    if (!selectedTemplate || !previewFirstPoliza) return null;
    return buildContactAssignmentPayload(selectedTemplate, previewFirstPoliza, previewResolvedValues)._preview;
  })();
  const previewBodyWithOverrides = (() => {
    if (!previewMessage || !selectedTemplate || !previewFirstPoliza) return "";
    return (selectedTemplate.body || "").replace(/\{\{(\d+)\}\}/g, (_, index) => {
      const value = previewResolvedValues[Number(index) - 1];
      return value ?? `{{${index}}}`;
    });
  })();

  return (
    <>
      <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.1/xlsx.full.min.js"></script>
      <div className={`${isDarkMode ? "bg-[#0f1115] text-[#e5e7eb]" : "bg-[#f8fafc] text-gray-800"} h-[calc(100vh-42px)] p-6 rounded-md w-full flex flex-col overflow-hidden`}>
        <div className={`${isDarkMode ? "bg-[#171a21] border-[#2b313d]" : "bg-white border-gray-200"} border rounded-2xl px-6 py-5 shadow-md mb-6`}>
          <div className="flex items-start justify-between gap-4">
            <div>
              <h2 className={`text-2xl font-bold ${isDarkMode ? "text-white" : "text-gray-900"}`}>Renovaciones</h2>
              <span className={`text-sm ${isDarkMode ? "text-[#a1a8b5]" : "text-gray-500"}`}>
                {checkedItems.length > 0
                  ? checkedItems.length + " Seleccionados"
                  : "Seleccione y envie plantillas a clientes"}
              </span>
            </div>
            <button
              type="button"
              onClick={() => setIsDarkMode((prev) => !prev)}
              className={`${isDarkMode ? "bg-[#0f1115] border-[#2b313d] text-[#d1d5db]" : "bg-white border-gray-300 text-gray-700"} inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-sm`}
            >
              <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
              {isDarkMode ? "Light mode" : "Dark mode"}
            </button>
          </div>
        </div>
        <div className={`${isDarkMode ? "bg-[#171a21] border-[#2b313d]" : "bg-white border-gray-200"} border shadow-sm rounded-xl p-4 mb-4`}>
          <div className="flex flex-wrap items-center gap-3">
          <div className={`${isDarkMode ? "bg-[#0f1115] border-[#2b313d]" : "bg-white border-gray-300"} flex items-center p-2 rounded-md border min-w-[240px]`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={`h-5 w-5 ${isDarkMode ? "text-[#6b7280]" : "text-gray-400"}`}
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"
              />
            </svg>
            <input
              onChange={handleSearch}
              value={searchTerm}
              className={`${isDarkMode ? "bg-[#0f1115] text-[#d1d5db]" : "bg-white text-gray-700"} outline-none ml-1 block border-none mr-2 text-sm`}
              type="text"
              name=""
              id=""
              placeholder="Buscar..."
            />
          </div>
            <DatePickerCustom
              value={selectedDate}
              onChange={handleDateChange}
            />
            <select onChange={selectTipoRenovacion} className={topControlClassName}>
              <option value="">Tipo Renov.</option>
              {
                TipoRenovacionList.map((tipoRenovacion) => {
                  return <option value={tipoRenovacion.id}>{tipoRenovacion.name}</option>
                })
              }
            </select>
            <select onChange={selectTemplate} className={topControlClassName}>
              <option value="">Seleccione plantilla</option>
              {templates.map((template) => {
                return <option value={template._id}>{template.name}</option>;
              })}
            </select>
            <select id="selectejecutivo" className={topControlClassName} onChange={(e) => handleSelectedEjecutivo(e.target.value)}>
              <option>Ejecutivo</option>
              {ejecutivos.map((ejecutivo) => {
                return <option value={ejecutivo._id}>{ejecutivo.firstName} {ejecutivo.lastName}</option>;
              })}
            </select>
            <button
              onClick={() => setColumnsModalOpen(true)}
              className={`${isDarkMode ? "border-[#2b313d] text-[#d1d5db] bg-[#0f1115] hover:bg-[#1f2430]" : "border-gray-300 text-gray-700 bg-white hover:bg-gray-100"} inline-flex items-center gap-2 px-4 py-2 border rounded-lg text-sm font-medium transition`}
            >
              <FontAwesomeIcon icon={faColumns} />
              Columnas ({selectedVisibleColumns.length})
            </button>
            <button
              onClick={sendTemplateMessages}
              className="inline-block px-6 py-2.5 bg-[#2f6feb] text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-[#3b82f6] transition duration-150 ease-in-out"
            >
              Send Messages
            </button>
            <button
              className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] hover:bg-[#2b313d]" : "bg-gray-100 text-gray-700 hover:bg-gray-200"} inline-block px-6 py-2.5 font-medium text-xs leading-tight uppercase rounded-full shadow-md transition duration-150 ease-in-out`}
              onClick={resetFilters}
            >
              <FontAwesomeIcon icon={faFilter} /> Reset
            </button>
            <button
              onClick={generateExcelFromJSON}
              className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] hover:bg-[#2b313d]" : "bg-gray-100 text-gray-700 hover:bg-gray-200"} inline-block px-6 py-2.5 font-medium text-xs leading-tight uppercase rounded-full shadow-md transition duration-150 ease-in-out`}
            >
              Export
            </button>
          </div>
          <div className="mt-4">
            <ReactSelect
              isMulti
              options={availableColumns.map((column) => ({
                value: column,
                label: columnLabelMap[column] || column,
              }))}
              value={activeFilterColumns.map((column) => ({
                value: column,
                label: columnLabelMap[column] || column,
              }))}
              onChange={(options) => setActiveFilterColumns((options || []).map((opt) => opt.value))}
              closeMenuOnSelect={false}
              styles={reactSelectFilterStyles}
              placeholder="Selecciona columnas para filtrar..."
            />
          </div>
          {activeFilterColumns.length > 0 && (
            <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-2">
              {activeFilterColumns.map((column) => (
                <div key={`filter-values-${column}`} className="grid grid-cols-[1fr_auto] gap-2">
                  <ReactSelect
                    isMulti
                    options={getUniqueColumnOptions(column)}
                    value={(columnFilters[column] || []).map((value) => ({ value, label: value }))}
                    onChange={(options) => handleApplyColumnFilter(column, options)}
                    closeMenuOnSelect={false}
                    styles={reactSelectFilterStyles}
                    placeholder={`Valores: ${columnLabelMap[column] || column}`}
                  />
                  <button
                    type="button"
                    onClick={() => clearSingleFilter(column)}
                    className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d] hover:bg-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"} px-3 py-2 text-xs rounded-md border`}
                  >
                    Limpiar
                  </button>
                </div>
              ))}
            </div>
          )}
          {Object.entries(columnFilters).some(([, values]) => values?.length) && (
            <div className="mt-3 flex flex-wrap gap-2">
              {Object.entries(columnFilters)
                .filter(([, values]) => values?.length)
                .map(([column, values]) => (
                  <span
                    key={`chip-${column}`}
                    className={`${isDarkMode ? "bg-[#222733] text-[#d1d5db] border-[#2b313d]" : "bg-gray-100 text-gray-700 border-gray-300"} inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border`}
                  >
                    {(columnLabelMap[column] || column) + `: ${values.length}`}
                    <button type="button" onClick={() => clearSingleFilter(column)} className={`${isDarkMode ? "text-[#9ca3af] hover:text-white" : "text-gray-500 hover:text-gray-800"}`}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  </span>
                ))}
            </div>
          )}
        </div>
        <div className="flex flex-col mt-5 min-h-0 flex-1">
          <div className="w-full min-h-0 flex-1">
            <div className={`${isDarkMode ? "border-[#2b313d] bg-[#171a21]" : "border-gray-200 bg-white"} minimal-horizontal-scroll h-full overflow-auto rounded-lg border`}>
              <div className="min-w-max min-h-full">
                <table className="w-full min-w-max">
                  <thead className={`${isDarkMode ? "border-[#2b313d]" : "border-gray-200"} border-b`}>
                    <tr>
                      <th
                        scope="col"
                        className={`${isDarkMode ? "text-[#9ca3af] bg-[#1f2430]" : "text-gray-500 bg-gray-50"} text-xs tracking-wide uppercase font-medium px-4 py-3 text-left`}
                      >
                        #
                      </th>
                      <th
                        scope="col"
                        className={`${isDarkMode ? "text-[#9ca3af] bg-[#1f2430]" : "text-gray-500 bg-gray-50"} text-xs tracking-wide uppercase font-medium px-4 py-3 text-left`}
                      >
                        <input type="checkbox" onChange={checkAll} />
                      </th>
                      {selectedVisibleColumns.map((column) => (
                        <th
                          key={`header-${column}`}
                          scope="col"
                          className={`${isDarkMode ? "text-[#9ca3af] bg-[#1f2430]" : "text-gray-500 bg-gray-50"} text-xs tracking-wide uppercase font-medium px-4 py-3 text-left`}
                        >
                          {renderHeaderForColumn(column)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {polizasFiltered.length > 0 ? (
                      polizasFiltered.map((poliza, index) => {
                        return (
                          <tr className={`${isDarkMode ? "border-[#2b313d] hover:bg-[#1b2029]" : "border-gray-200 hover:bg-gray-50"} border-b`}>
                            <td className={`${isDarkMode ? "text-[#e5e7eb]" : "text-gray-900"} px-4 py-3 whitespace-nowrap text-sm font-medium`}>
                              {index + 1}
                            </td>
                            <td className={`${isDarkMode ? "text-[#cbd5e1]" : "text-gray-700"} text-sm font-light px-4 py-3 whitespace-nowrap`}>
                              <input
                                type="checkbox"
                                data-id={poliza._id}
                                key={index}
                                onChange={handleCheck}
                              />
                            </td>
                            {selectedVisibleColumns.map((column) => (
                              <td
                                key={`cell-${poliza._id}-${column}`}
                                className={`${isDarkMode ? "text-[#cbd5e1]" : "text-gray-700"} text-sm font-light px-4 py-3 whitespace-nowrap`}
                              >
                                {renderCellForColumn(column, poliza)}
                              </td>
                            ))}
                          </tr>
                        );
                      })
                    ) : (
                      <div className={`${isDarkMode ? "text-[#9ca3af]" : "text-gray-500"} text-center py-6`}>
                        <FontAwesomeIcon icon={faSpinner} spinPulse />
                      </div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {columnsModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
          <div className="bg-white w-11/12 md:max-w-xl rounded-xl border border-gray-200 shadow-xl">
            <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-800">Columnas visibles</h3>
              <button
                onClick={() => setColumnsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <div className="px-5 py-4">
              <p className="text-sm text-gray-500 mb-3">
                Las columnas se cargan automaticamente desde los datos obtenidos en polizas.
              </p>
              <div className="flex gap-2 mb-3">
                <button
                  type="button"
                  onClick={selectAllColumns}
                  className="px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                >
                  Seleccionar todas
                </button>
                <button
                  type="button"
                  onClick={clearColumnsSelection}
                  className="px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                >
                  Limpiar
                </button>
              </div>
              <div className="mb-4">
                <p className="text-xs font-semibold text-gray-600 mb-2">Orden de columnas visibles</p>
                <div className="max-h-40 overflow-y-auto border border-gray-100 rounded-md p-2 space-y-2 bg-gray-50">
                  {selectedVisibleColumns.map((column, index) => (
                    <div key={`selected-order-${column}`} className="flex items-center justify-between bg-white border border-gray-100 rounded-md px-2 py-1.5">
                      <span className="text-sm text-gray-700">{columnLabelMap[column] || column}</span>
                      <div className="flex items-center gap-1">
                        <button
                          type="button"
                          onClick={() => moveVisibleColumn(column, "up")}
                          disabled={index === 0}
                          className="px-2 py-0.5 text-xs border border-gray-200 rounded disabled:opacity-40"
                        >
                          ↑
                        </button>
                        <button
                          type="button"
                          onClick={() => moveVisibleColumn(column, "down")}
                          disabled={index === selectedVisibleColumns.length - 1}
                          className="px-2 py-0.5 text-xs border border-gray-200 rounded disabled:opacity-40"
                        >
                          ↓
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="max-h-80 overflow-y-auto grid grid-cols-1 sm:grid-cols-2 gap-2">
                {availableColumns.map((column) => (
                  <label
                    key={column}
                    className="flex items-center gap-2 p-2 rounded-md border border-gray-100 hover:bg-gray-50"
                  >
                    <input
                      type="checkbox"
                      checked={selectedVisibleColumns.includes(column)}
                      onChange={() => toggleVisibleColumn(column)}
                    />
                    <span className="text-sm text-gray-700">
                      {columnLabelMap[column] || column}
                    </span>
                  </label>
                ))}
              </div>
            </div>
            <div className="px-5 py-3 border-t border-gray-100 flex justify-end">
              <button
                onClick={() => setColumnsModalOpen(false)}
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-500"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        style={{ display: "none" }}
        className="main-modal fixed w-full h-100 inset-0 z-50 overflow-hidden flex justify-center items-center animated fadeIn faster backdrop-blur-sm bg-black/30"
      >
        <div className="border border-gray-200 rounded-lg shadow-lg modal-container bg-white w-[96vw] max-w-6xl max-h-[92vh] mx-auto z-50 overflow-y-auto">
          <div className="modal-content py-4 text-left px-6">
            <div className="flex justify-between items-center pb-3">
              <p className="text-2xl font-bold">Enviando Mensajes..</p>
              <div
                className="modal-close cursor-pointer z-50"
                onClick={closeModal}
              >
                <svg
                  className="fill-current text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                </svg>
              </div>
            </div>
            <div className="my-5">
              {modalStep === "confirm" && previewMessage && (
                <div>
                  <p className="text-sm text-gray-600 mb-3">
                    Se enviaran {previewMessage.total} mensajes. Vista previa del primer mensaje:
                  </p>
                  <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-4">
                    <div>
                      <div className="mb-4 border rounded-lg p-3 bg-gray-50 max-h-72 overflow-y-auto">
                        <p className="text-xs text-gray-500 mb-2">
                          Variables del template (valor fijo opcional para este envio masivo):
                        </p>
                        {Array.from({ length: getTemplateVariableCount(selectedTemplate) }, (_, i) => i + 1).map((varIndex) => (
                          <div key={varIndex} className="grid grid-cols-12 gap-2 items-center mb-2">
                            <div className="col-span-2 text-xs font-semibold">{`{{${varIndex}}}`}</div>
                            <input
                              className="col-span-6 border rounded px-2 py-1 text-sm"
                              placeholder="Valor fijo (opcional)"
                              value={variableOverrides[varIndex] ?? ""}
                              onChange={(event) =>
                                setVariableOverrides((prev) => ({
                                  ...prev,
                                  [varIndex]: event.target.value,
                                }))
                              }
                            />
                            <select
                              className="col-span-4 border rounded px-2 py-1 text-xs"
                              value=""
                              onChange={(event) => {
                                const selectedField = event.target.value;
                                if (!selectedField || !currentEjecutivoForOverrides) return;
                                setVariableOverrides((prev) => ({
                                  ...prev,
                                  [varIndex]: `${currentEjecutivoForOverrides[selectedField] ?? ""}`,
                                }));
                              }}
                            >
                              <option value="">Dato ejecutivo</option>
                              {ejecutivoFieldOptions.map((field) => (
                                <option key={field} value={field}>
                                  {field}
                                </option>
                              ))}
                            </select>
                          </div>
                        ))}
                      </div>
                      <div className="border rounded-lg p-3 bg-gray-50">
                        <p className="text-xs text-gray-500 mb-2">Prueba individual</p>
                        <div className="flex gap-2">
                          <input
                            className="flex-1 border rounded px-3 py-2 text-sm"
                            placeholder="Numero de telefono para prueba"
                            value={customTestPhone}
                            onChange={(event) => setCustomTestPhone(event.target.value)}
                          />
                          <button
                            type="button"
                            onClick={sendTestTemplateMessage}
                            className="px-3 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-500"
                          >
                            Enviar prueba
                          </button>
                        </div>
                        {testSendStatus && (
                          <p className="text-xs text-gray-600 mt-2">{testSendStatus}</p>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-center">
                      <div className="w-[320px] h-[600px] rounded-[2rem] border-[6px] border-slate-800 bg-slate-900 overflow-hidden shadow-lg">
                        <div className="h-full bg-[#E5DDD5] flex flex-col">
                          <div className="bg-[#075E54] text-white px-3 py-2 text-sm font-semibold">
                            {previewMessage.asegurado || "Cliente"}
                          </div>
                          <div className="p-2 flex-1 overflow-y-auto">
                            <div className="bg-white rounded-lg rounded-tl-none shadow-sm overflow-hidden">
                              {previewMessage.image && (
                                <div className="w-full aspect-[1.91/1] bg-slate-100">
                                  <img
                                    src={previewMessage.image}
                                    alt="Preview"
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              )}
                              <div className="p-3">
                                <p className="text-[13px] leading-relaxed whitespace-pre-wrap break-words">
                                  {previewBodyWithOverrides || previewMessage.body || "Sin contenido"}
                                </p>
                                <div className="mt-2 border-t border-dashed border-slate-200 pt-2 text-[11px] text-slate-600">
                                  <p>Asignacion contacto:</p>
                                  <p>Nombre cliente: {previewContactAssignment?.nombreCliente || "-"}</p>
                                  <p>Ejecutivo nombre: {previewContactAssignment?.ejecutivoName || "-"}</p>
                                  <p>Campo id ejecutivo: {previewContactAssignment?.ejecutivoIdField || "-"}</p>
                                  <p>Fallback ejecutivo: {previewContactAssignment?.fallbackEjecutivoId || "-"}</p>
                                  <p>Ejecutivo id: {previewContactAssignment?.ejecutivoId || "-"}</p>
                                </div>
                                <div className="flex justify-end text-[10px] text-slate-400 mt-1">
                                  ahora
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {modalStep !== "confirm" && (
                <div>
                  <p>{modalMessageBody}</p>
                  <div className="w-full bg-gray-200 h-1 rounded-lg mt-5">
                    <div
                      className="bg-blue-600 h-3 rounded-lg"
                      style={{ width: sentItems + "%" }}
                    ></div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-end pt-2">
              <button
                onClick={closeModal}
                className="focus:outline-none modal-close px-4 bg-gray-400 p-3 rounded-lg text-white hover:bg-gray-300"
              >
                {modalStep === "confirm" ? "Cancelar" : "Cerrar"}
              </button>
              {modalStep === "confirm" && (
                <button
                  onClick={confirmSendTemplateMessages}
                  className="focus:outline-none px-4 bg-teal-500 p-3 ml-3 rounded-lg text-white hover:bg-teal-400"
                >
                  Confirmar envio
                </button>
              )}
              {modalStep === "sending" && (
                <button
                  disabled
                  className="focus:outline-none px-4 bg-slate-300 p-3 ml-3 rounded-lg text-white"
                >
                  Enviando...
                </button>
              )}
              {modalStep === "done" && (
                <button
                  onClick={closeModal}
                  className="focus:outline-none px-4 bg-teal-500 p-3 ml-3 rounded-lg text-white hover:bg-teal-400"
                >
                  Listo
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
